import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, ViewChild } from '@angular/core';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { DialogService } from '../../../dialog/dialog.service';
import { DialogModalSize } from '../../../dialog/dialog-ref';
import { AIService } from '../../services/ai.service';
import { DialogConfig } from '../../../dialog/dialog-config';

@Component({
    selector: 'app-kx-ai-editing',
    templateUrl: './kx-ai-editing.component.html',
    styleUrls: ['./kx-ai-editing.component.scss'],
    standalone: false
})
export class KxAIEditingComponent implements OnInit {
  public config:any = {};
  @ViewChild('customComponent', { read: ViewContainerRef }) customComponent: ViewContainerRef;
  constructor(
    public rolePermissionService:RolePermissionService,
    public baseService:BaseService,
    public aiService:AIService,
    public alertService:AlertsService,
    public dialogService: DialogService,
    public dialogConfig: DialogConfig,
    public loader:LoaderService
  ) {    
  
   
  }

  ngOnInit() {
    console.log(this.config,this.dialogConfig)
   if(this.dialogConfig.data.menuData.audit_log_id != undefined){
    this.loader.showSpinner();
    let data = {
          "filter": '_id:'+this.dialogConfig.data.menuData.audit_log_id,
          "projectionKeys": 'ai_output,final_prompt_code,feature,resource'
      }
      this.baseService.getData(data, "", "ai_audit_logs","aiml-gateway","GET_PAGE").subscribe(
        res => {
          this.loader.hideSpinner()
          if (res && res.errCode != undefined && res.errCode == 0 && res.resource && res.resource.length > 0) {
            try{
              var message = JSON.parse(res.resource[0].ai_output)
              switch(res.resource[0].final_prompt_code) {
                case "bill_editing_scan_fill":
                case "bill_editing_scan_fill__final":
                    this.openCustomComponent("app-kx-ai-reciept-editor",{receiptData:message,documentId:this.dialogConfig.data.menuData.document_id});
                  break;
              
                default:
                  break;
              }
            }catch(e){
              console.error(e)
              this.showError();
            }
            
            
          }else{
            this.showError();
          }
        },
        error=>{
          this.loader.hideSpinner()
          this.showError();
        })
      }else{
        this.showError();
      }
  }

  showError(){
    this.alertService.error("Editing Error")
  }

  openCustomComponent(selector,input) {
       this.aiService.createComponent(this.customComponent,selector,input,(response)=>{
      if (response) { 
      }
    })
  }

}
